"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sparxScroller;
var _containerChecker2 = _interopRequireDefault(require("./containerChecker"));
function sparxScroller(ref, options) {
  var _containerChecker$own, _containerChecker, _containerChecker$own2, _containerChecker$own3;
  var scrollElement = (_containerChecker$own = (_containerChecker = (0, _containerChecker2.default)(ref.current)) === null || _containerChecker === void 0 ? void 0 : (_containerChecker$own2 = _containerChecker.ownerDocument) === null || _containerChecker$own2 === void 0 ? void 0 : (_containerChecker$own3 = _containerChecker$own2.host) === null || _containerChecker$own3 === void 0 ? void 0 : _containerChecker$own3.closest('#page_content')) !== null && _containerChecker$own !== void 0 ? _containerChecker$own : ref.current;
  typeof scrollElement.scrollTo === 'function' && scrollElement.scrollTo(options);
}